import { Reveal, MaskLineInView } from "./Reveal";
import { scrollToId as scrollTo } from "@/lib/scroll";
import { ArrowUpRight } from "lucide-react";

export default function Promise() {
  return (
    <section className="relative py-16 lg:py-24 border-t border-white/10" data-testid="promise">
      <div className="mx-auto max-w-[1000px] px-6 lg:px-10 text-center">
        <Reveal className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-8 inline-flex items-center gap-3">
          <span className="h-px w-10 bg-[#FF3B00]" /> Unser Versprechen <span className="h-px w-10 bg-[#FF3B00]" />
        </Reveal>
        <h2 className="font-display text-4xl md:text-6xl leading-[1] tracking-tight text-white uppercase mb-8">
          <MaskLineInView>Ihre Website soll Ihnen</MaskLineInView>
          <MaskLineInView delay={0.1}>Arbeit abnehmen –</MaskLineInView>
          <MaskLineInView delay={0.2} className="text-[#FF3B00]">nicht neue machen.</MaskLineInView>
        </h2>
        <Reveal delay={0.2} className="text-neutral-300 text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
          Sie möchten sich auf Ihr Unternehmen und Ihre Kunden konzentrieren? Genau dafür gibt es
          unseren Website-Service. Wir kümmern uns um Erstellung, Domain, Hosting und Technik. Und
          wenn sich in Ihrem Unternehmen etwas verändert, übernehmen wir je nach Paket auch die
          Aktualisierung Ihrer Website.
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-10 font-display text-2xl md:text-3xl text-white">
            Sie führen Ihr Unternehmen.<br className="hidden sm:block" />{" "}
            <span className="text-[#FF3B00]">Wir kümmern uns um Ihre Website.</span>
          </p>
          <button
            onClick={() => scrollTo("#kontakt")}
            className="group mt-10 inline-flex items-center gap-2 bg-[#FF3B00] text-white font-tech text-sm uppercase tracking-[0.12em] px-8 py-4 hover:bg-[#FF5C2B] active:scale-95 transition-all duration-200"
            data-testid="promise-cta"
          >
            Unverbindlich anfragen
            <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
